import { useState } from 'react';
import { useAlert } from 'react-alert';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import I18n from 'i18n-js';

// @ts-ignore lib
import { deleteAccount } from '@lootboy/lib/actions/UserActions';

import Alert from '~/components/Alert';
import Input from '~/components/atoms/FormControls/Input';
import StyledButton from '~/components/atoms/StyledButton';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import { MENU_DIALOG_CONTAINER_ID } from '~/config';
import { usernameSelector } from '~/redux/selectors/user';
import { useAppDispatch } from '~/redux/store/useAppDispatch';
import { HOME_PATH } from '~/routes/paths';
import { parseLootBoyError } from '~/utilities/errors';

import styles from './DeleteAccountPopup.module.scss';

const SAFE_WORD = 'Goodbye';

export function DeleteAccountPopup({
  close,
}: {
  close: () => void;
}): JSX.Element {
  const alert = useAlert();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [safety, setSafety] = useState('');
  const username = useSelector(usernameSelector);

  return (
    <BottomSheetDialog
      elementIdToAnimate={MENU_DIALOG_CONTAINER_ID}
      onClose={close}
      header={I18n.t('MenuView_profile_delete_bc')}
      dialogLevel={1}
      renderFooter={({ closeDialog }) => (
        <div className={styles.footerContent}>
          <StyledButton
            className={styles.deleteButton}
            disabled={safety !== SAFE_WORD}
            onClick={async () => {
              try {
                history.push(HOME_PATH);
                await dispatch(deleteAccount());
                alert.success(
                  <Alert
                    title={I18n.t('DeleteAccountView_deleted_successful')}
                  />,
                );
              } catch (error) {
                const { message } = parseLootBoyError(
                  error,
                  I18n.t('DeleteAccountView_deleted_failed'),
                );
                alert.error(
                  <Alert
                    title={I18n.t('common_error')}
                    body={message}
                  />,
                );
              }
            }}
          >
            {I18n.t('MenuView_profile_delete_sbutton')}
          </StyledButton>
          <StyledButton
            className={styles.keepButton}
            onClick={closeDialog}
          >
            {I18n.t('MenuView_profile_delete_pbutton')}
          </StyledButton>
        </div>
      )}
    >
      <div className={styles.content}>
        <h1 className={styles.heading}>{I18n.t('common_are_you_sure')}</h1>
        <p className={styles.infoText}>
          {I18n.t('MenuView_profile_delete_sub', { username })}
        </p>
        <Input
          id="delete_account_test"
          label=""
          type="text"
          placeholder={I18n.t('MenuView_profile_delete_placeholder')}
          className={styles.input}
          value={safety}
          onChange={(event) => setSafety(event.target.value)}
        />
      </div>
    </BottomSheetDialog>
  );
}
